import { get } from 'lodash';
import uuidHelper, { findWithUUID } from '@/utils/uuidHelper';
import { assignValue } from '@/utils/resultsHelper';
import { linkPrefixes, splitUrl } from '@/constants/urls';

export const assignLookupEditProps = (lookup) => {
  lookup.options.forEach((option) => assignValue(option, 'uri', splitUrl(option.uri)));
};

const newLookupItem = () => (
  {
    description: '',
    name: '',
    uri: { link: null, protocol: linkPrefixes.HTTPS },
    uuid: uuidHelper.generate(),
  }
);

export const activeLookup = (lookups) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);
  return dictionary.lookups[lookups.activeLookupName];
};

export const lookupProps = (draft, action) => {
  const props = { ...action, activeDictionaryUUID: '', activeLookupName: '' };
  const dictionary = findWithUUID(draft.lookups.dictionaries, action.dictionaryUUID);

  if (dictionary) {
    const dictionaryFields = get(dictionary, 'fields', [{ uuid: '' }]);
    const dictionaryLookups = get(dictionary, 'lookups', {});
    props.activeDictionaryUUID = dictionary.uuid;
    props.activeFieldUUID = dictionaryFields.length ? dictionaryFields[0].uuid : '';
    [props.activeLookupName] = Object.keys(dictionaryLookups).sort();
  }

  return props;
};

export default newLookupItem;
